export function getEndConversationDestination({ selectedActivity } = {}) {
  return selectedActivity?.startsWith('learning-path-') ? 'planner' : 'activities';
}
